import React, { useState } from 'react';
import './Styles.css';
import Modal from '../../../../Elements/ids/Modal';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import RemoveAgentButtons from './Buttons/RemoveAgentButtons';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import { ServiceClient } from '../../../../Services/ServiceClient';
import { createServerErrorMessage } from '../../../../Helpers/FormInputHelper';
import { getNewEmployer } from './Functions';
import { updateAgentEmployerFieldNumber } from '../../Functions';

const RemoveAgent = ({ employer, employerAgent, closeView, setEmployer }) => {
  const [error, setError] = useState(null);

  const onSubmit = event => {
    event.preventDefault();

    ServiceClient.updateAgentInfo(
      { code: employerAgent.agentCode, employerId: null },
      updateAgentEmployerFieldNumber,
      () => {
        setEmployer(getNewEmployer(employer, employerAgent.agentCode));
        closeView();
      },
      error => {
        setError(createServerErrorMessage(error).message);
      }
    );
  };

  return (
    <Modal
      closeView={closeView}
      titleText={formatMessage(Messages.employerPage_removeAgent_title)}
      buttons={<RemoveAgentButtons closeView={closeView} onClickEvent={onSubmit} />}>
      <div className="employer_page-remove_agent-text">
        {formatMessage(Messages.employerPage_removeAgent_text, { agentCode: employerAgent.agentCode })}
        <ErrorMessage message={error} />
      </div>
    </Modal>
  );
};

export default RemoveAgent;
